import {
  getOrganizationList,
  createOrganization,
  updateOrg,
  getChildOrganizationList
} from '@/api/sys.organization'

export default {
  namespaced: true,
  actions: {
    /**
     * 分页查询
     */
    getOrganizationList ({
      dispatch
    }, {
      vm,
      pageable
    }) {
      return getOrganizationList(pageable)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * @description 新增机构
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param data {Object} 数据
     */
    addOrganization ({
      dispatch
    }, {
      vm,
      organization
    }) {
      // 开始请求
      return createOrganization(organization)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateOrg ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return updateOrg(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    getChildOrganizationList ({
      dispatch
    }, {
      vm,
      pageable
    }) {
      // 开始请求
      return getChildOrganizationList(pageable)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
  }
}
